const suffix = ` | Orrefors`;
export default suffix;
